import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _BaseRCE5Renderer;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */

import { Component } from 'react';
import PropTypes, { shape, string, object, oneOfType } from 'prop-types';
import { enhanceUserContent } from '@instructure/canvas-rce';
import mathRenderer from './mathRenderer';
import { RceConfigKeys, withStyleOverrides } from '@instructure/quiz-common';
import { jsx, Global } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import classnames from 'classnames';
var BaseRCE5Renderer = /*#__PURE__*/function (_Component) {
  function BaseRCE5Renderer() {
    var _this2;
    _classCallCheck(this, BaseRCE5Renderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BaseRCE5Renderer, [].concat(args));
    _defineProperty(_this2, "state", {
      richContentIsOverflowing: false
    });
    _defineProperty(_this2, "_contentRef", null);
    _defineProperty(_this2, "resizeObserver", null);
    _defineProperty(_this2, "handleContentRef", function (node) {
      return _this2._contentRef = node;
    });
    _defineProperty(_this2, "enhanceContent", function () {
      var _this2$props$enhancem, _this2$props$featureF;
      enhanceUserContent(_this2._contentRef, {
        canvasOrigin: (_this2$props$enhancem = _this2.props.enhancementProps) === null || _this2$props$enhancem === void 0 ? void 0 : _this2$props$enhancem.canvasOrigin,
        canvasLinksTarget: 'canvas',
        containingCanvasLtiToolId: _this2.props.canvasToolId,
        replaceInstFSLinksWithOldLinks: (_this2$props$featureF = _this2.props.featureFlags) === null || _this2$props$featureF === void 0 ? void 0 : _this2$props$featureF.displayOldLinks
      });
    });
    _defineProperty(_this2, "checkRCEOverflow", function (contentElement) {
      var richContentIsOverflowing = contentElement.clientWidth > 1 && (contentElement.clientWidth < contentElement.scrollWidth || contentElement.clientHeight < contentElement.scrollHeight);
      if (richContentIsOverflowing !== _this2.state.richContentIsOverflowing) {
        _this2.setState({
          richContentIsOverflowing: richContentIsOverflowing
        });
      }
    });
    _defineProperty(_this2, "triggerMathRendering", function () {
      mathRenderer.debouncedDocumentRendering();
    });
    // for the sidebar, content can be either collapsed or expanded and is controlled by a css class
    // this is why we need to check if the content element has been resized and check for overflow
    _defineProperty(_this2, "initializeResizeObserver", function () {
      var _this2$_contentRef;
      var contentElement = (_this2$_contentRef = _this2._contentRef) === null || _this2$_contentRef === void 0 ? void 0 : _this2$_contentRef.querySelector('.user_content');
      if (contentElement) {
        _this2.resizeObserver = new ResizeObserver(function () {
          return _this2.checkRCEOverflow(contentElement);
        });
        _this2.resizeObserver.observe(contentElement);
      }
    });
    _defineProperty(_this2, "componentDidMount", function () {
      _this2.enhanceContent();
      _this2.triggerMathRendering();
      _this2.initializeResizeObserver();
    });
    _defineProperty(_this2, "componentDidUpdate", function (prevProps) {
      if (_this2.props.content === prevProps.content) return;
      _this2._contentRef.querySelectorAll('.user_content.enhanced').forEach(function (e) {
        return e.classList.remove('enhanced');
      });
      _this2.enhanceContent();
      _this2.triggerMathRendering();
    });
    _defineProperty(_this2, "componentWillUnmount", function () {
      if (_this2.resizeObserver) {
        _this2.resizeObserver.disconnect();
      }
    });
    return _this2;
  }
  _inherits(BaseRCE5Renderer, _Component);
  return _createClass(BaseRCE5Renderer, [{
    key: "tabIndex",
    value: function tabIndex() {
      if (this.props.ariaHidden) {
        return -1;
      }
      // overflowing content should be focusable so that keyboard users can scroll it
      return this.state.richContentIsOverflowing ? 0 : -1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$customSty;
      var _this$props$defaultRc = this.props.defaultRceSettings,
        enabled = _this$props$defaultRc.enabled,
        font = _this$props$defaultRc.font,
        fontSize = _this$props$defaultRc.fontSize;
      var userSetDefaultStyles = enabled ? {
        fontFamily: font,
        fontSize: fontSize
      } : {};
      var rceStyle = !this.props.content ? this.props.styles.rceNoContent : this.props.styles.rceWithContent;
      return jsx("div", {
        ref: this.handleContentRef,
        css: this.props.styles.container,
        tabIndex: -1
      }, jsx(Global, {
        styles: {
          '.screenreader-only': this.props.styles.screenReaderOnly
        }
      }), jsx("div", {
        tabIndex: this.tabIndex(),
        className: classnames('user_content', (_this$props$customSty = this.props.customStyles.label) !== null && _this$props$customSty !== void 0 ? _this$props$customSty : ''),
        css: [this.props.styles.content, this.props.customStyles, userSetDefaultStyles, rceStyle],
        dangerouslySetInnerHTML: {
          __html: this.props.content
        }
      }));
    }
  }]);
}(Component);
_BaseRCE5Renderer = BaseRCE5Renderer;
_defineProperty(BaseRCE5Renderer, "displayName", 'RCE5Renderer');
_defineProperty(BaseRCE5Renderer, "componentId", "Quizzes".concat(_BaseRCE5Renderer.displayName));
_defineProperty(BaseRCE5Renderer, "propTypes", {
  content: oneOfType([string, object]),
  customStyles: PropTypes.object,
  defaultRceSettings: PropTypes.shape({
    enabled: PropTypes.bool,
    font: PropTypes.string,
    fontSize: PropTypes.string
  }),
  enhancementProps: shape(_defineProperty({}, RceConfigKeys.canvasOrigin, string)),
  canvasToolId: string,
  styles: PropTypes.object,
  featureFlags: shape({
    displayOldLinks: PropTypes.bool
  }),
  ariaHidden: PropTypes.bool
});
_defineProperty(BaseRCE5Renderer, "defaultProps", {
  customStyles: {},
  content: '',
  defaultRceSettings: {},
  enhancementProps: null,
  canvasToolId: null,
  canvasConfig: null,
  ariaHidden: false,
  featureFlags: null
});
_defineProperty(BaseRCE5Renderer, "mathJaxConfig", {
  messageStyle: 'none'
});
export var RCE5Renderer = withStyleOverrides(generateStyle, generateComponentTheme)(BaseRCE5Renderer);
export default RCE5Renderer;